import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { ImagePlus, Trash2, X } from "lucide-react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDetalleBanner, postCrearBanner, postUpdateBanner } from "../../../api/ApiService";



function AddBannerPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [linkUrl, setLinkUrl] = useState('');
    const [imagen, setImagen] = useState('');
    const [activoStatus, setActivoStatus] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [formData, setFormData] = useState({
        imagenPreview: '',
        imagenFile: null,
    });

    const params = useParams();

    const { id } = params;

    const [searchParams] = useSearchParams();

    const mode = searchParams.get('mode');


    const stateToken = useSelector(state => state.reducerGlobal.token);

    const navigate = useNavigate();



    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleBanner();
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 100);
        }
    }, [id, stateToken]);




    //==========================================================funcion para enviar encuesta a la api
    const handleDetalleBanner = () => {
        getDetalleBanner(stateToken?.access_token, id)
            .then(response => {
                console.log("getDetalleBanner", response);
                setCargando(true);
                const data = response;

                setTitulo(data?.titulo || '');
                setLinkUrl(data?.link || '');
                // setImagen(data?.imagen || '');
                setFormData((prev) => ({
                    ...prev,
                    imagenPreview: data?.imagen || '',
                    imagenFile: null,
                }));
                setActivoStatus(data?.activo ? true : false);
            })
            .catch(error => {
                console.log("error-getDetalleBanner", error);
                setLoadingGuardar(false);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };



    //=============================================api de actualizar banner
    const handleUpdateBannerApi = (formData) => {

        postUpdateBanner(stateToken?.access_token, formData, id)
            .then((response) => {
                console.log("response-postUpdateBanner", response);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('success');
                setMensaje('Guardado con exito');
                setTimeout(() => {
                    navigate('/app/admin/banners');
                }, 1500);

            })
            .catch((error) => {
                console.log("error-postUpdateBanner", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar el banner');

            });
    };




    //=============================================api de crear banner
    const handleAddBannerApi = (formData) => {

        postCrearBanner(stateToken?.access_token, formData)
            .then((response) => {
                console.log("response-postCrearBanner", response);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('success');
                setMensaje('Guardado con exito');

                setTimeout(() => {
                    navigate('/app/admin/banners');
                }, 1500);

                //limpiar campos
                setTitulo('');
                setLinkUrl('');
                // setImagen('');
                setFormData({
                    imagenPreview: '',
                    imagenFile: null,
                });
                setActivoStatus(false);





            })
            .catch((error) => {
                console.log("error-postCrearBanner", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar el banner');

            });
    };


    //=========================================================funcion para guardar
    const handleGuardar = () => {
        // let body = {};
        let formDataBody = new FormData();
        formDataBody.append('titulo', titulo);
        // Only append the file when a new image was picked. Appending a null
        // value would send the literal string "null" and fail image validation.
        if (formData?.imagenFile) {
            formDataBody.append('imagen', formData.imagenFile);
        }
        formDataBody.append('link', linkUrl);
        formDataBody.append('activo', activoStatus ? 1 : 0);

        console.log("formData", formDataBody);


        setLoadingGuardar(true);

        if (id) {
            //si hay id, se actualiza el banner
            handleUpdateBannerApi(formDataBody);
        } else {
            //si no hay id, se crea el banner
            handleAddBannerApi(formDataBody);
        }
    };

    //=========================================================funcion para agregar imagen
    const handleAgregarImagen = (event) => {
        const file = event.target.files[0];
        console.log("file", file);

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagen(e.target.result);
            };
            reader.readAsDataURL
                (file);
        }

    };


    const openAlert = (type, text) => {
        setSeverity(type);
        setMensaje(text);
        setOpen(true);
    };

    const handleAgregarImagenPrincipal = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const result = e.target?.result;
            if (!result) return;

            const img = new Image();
            img.onload = () => {
                if (img.width === 720 && img.height === 400) {
                    setFormData((prev) => ({
                        ...prev,
                        imagenPreview: result,
                        imagenFile: file,
                    }));
                } else {
                    openAlert("error", "La imagen debe tener dimensiones 720x400 px.");
                }
            };
            img.src = result;
        };
        reader.readAsDataURL(file);
    };

    const handleRemoveImagenPrincipal = () => {
        setFormData((prev) => ({
            ...prev,
            imagenPreview: "",
            imagenFile: null,
        }));

        const fileInput = document.getElementById("imagen_principal");
        if (fileInput) fileInput.value = "";
    };



    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            {mode === "view" ? "Detalle del Banner" : id ? "Editar Banner" : "Agregar Banner"}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleGuardar();
                                }}
                            >
                                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {/* <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Imagen Banner</label>

                                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-gray-400 transition-colors">
                                            <input id="banner_imagen" type="file" accept="image/*" className="hidden" onChange={handleAgregarImagen} />

                                            {!imagen ? (
                                                <label htmlFor="banner_imagen" className="cursor-pointer flex flex-col items-center text-center">
                                                    <ImagePlus className="w-8 h-8 text-gray-400 mb-2" />
                                                    <p className="text-sm text-gray-600">Seleccionar imagen</p>
                                                    <p className="text-xs text-gray-500 mt-1">Tamaño recomendado: 720 x 400</p>
                                                </label>
                                            ) : (
                                                <div className="flex flex-col items-center justify-center gap-3">
                                                    <img src={imagen} alt="Vista previa" className="w-full max-w-md rounded-md object-cover" />
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setImagen("");
                                                            const fileInput = document.getElementById("banner_imagen");
                                                            if (fileInput) fileInput.value = "";
                                                        }}
                                                        className="inline-flex items-center gap-2 text-red-600 hover:text-red-700 text-sm font-medium"
                                                    >
                                                        <Trash2 className="w-4 h-4" />
                                                        Quitar imagen
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div> */}
                                    <div className="">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Imagen Principal (720x400)
                                        </label>

                                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-gray-400 transition-colors">
                                            <input id="imagen_principal" type="file" accept="image/*" className="hidden" onChange={handleAgregarImagenPrincipal} />

                                            {!formData.imagenPreview ? (
                                                <label htmlFor="imagen_principal" className="cursor-pointer flex flex-col items-center text-center">
                                                    <ImagePlus className="w-8 h-8 text-gray-400 mb-2" />
                                                    <p className="text-sm text-gray-600">Seleccionar imagen</p>
                                                    <p className="text-xs text-gray-500 mt-1">PNG o JPG con tamaño exacto 720x400</p>
                                                </label>
                                            ) : (
                                                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                                                    <img src={formData.imagenPreview} alt="Vista previa" className="w-full max-w-[360px] aspect-[9/5] rounded-md object-cover" />
                                                    {mode !== "view" && (
                                                        <button
                                                            type="button"
                                                            onClick={handleRemoveImagenPrincipal}
                                                            className="inline-flex items-center gap-2 text-red-600 hover:text-red-700 text-sm font-medium"
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                            Cambiar imagen
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Título</label>
                                            <input
                                                type="text"
                                                value={titulo}
                                                onChange={(e) => setTitulo(e.target.value)}
                                                placeholder="Ej: Banner principal"
                                                disabled={mode === "view"}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Link</label>
                                            <input
                                                type="text"
                                                value={linkUrl}
                                                onChange={(e) => setLinkUrl(e.target.value)}
                                                placeholder="https://ejemplo.com"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                                disabled={mode === "view"}
                                                required
                                            />
                                        </div>







                                        <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                checked={activoStatus}
                                                disabled={mode === "view"}
                                                onChange={(e) => setActivoStatus(e.target.checked)}
                                                className="h-4 w-4 rounded border-gray-300 text-[#104063] focus:ring-[#104063]"
                                            />
                                            Activo
                                        </label>
                                    </div>
                                </div>

                                <div className="flex justify-start gap-3 p-6 border-t border-gray-200">
                                    {mode !== "view" && (
                                        <button type="submit" className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] text-white rounded-lg font-medium transition-colors"
                                            disabled={loadingGuardar}
                                        >
                                            {/* {id ? "Guardar cambios" : "Guardar"} */}
                                            {loadingGuardar ? "Guardando..." : id ? "Guardar cambios" : "Guardar"}
                                        </button>
                                    )}

                                    <button type="button" onClick={handleCancelar} className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors">
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddBannerPage;
